import type { Provider } from '@angular/core';
import { FactoryDocumentsStore } from '../document/+state/factory-documents.store';
import { FactoryStore } from '../factory/factory.store';
import { MachineParkStore } from '../machine-park/+state/machine-park.store';
import { FactoryProjectReferencesStore } from '../project-reference/+state/factory-project-references.store';
import { VirtualTourStore } from '../virtual-tour/+state/virtual-tour.store';
import { FactoryViewUiStore } from './+state/factory-view-ui.store';

/**
 * Bundles every signal store required by the read-only factory view page tree.
 *
 * @example
 * Component({
 *   providers: [provideFactoryViewStores(), provideFactoryViewI18n()],
 * })
 */
export function provideFactoryViewStores(): Provider[] {
  return [
    FactoryDocumentsStore,
    FactoryProjectReferencesStore,
    FactoryStore,
    FactoryViewUiStore,
    MachineParkStore,
    VirtualTourStore,
  ];
}
